module.exports = __webpack_public_path__ + "img/header-img.51c083aa.png";